import BackgroundColorMixin from '../ui/mixins/styleMixins/BackgroundColorMixin';
import BorderWidthMixin from '../ui/mixins/styleMixins/BorderWidthMixin';
import BorderColorMixin from '../ui/mixins/styleMixins/BorderColorMixin';
import BorderRadiusMixin from '../ui/mixins/styleMixins/BorderRadiusMixin';
import TextColorMixin from '../ui/mixins/styleMixins/TextColorMixin';

const SUPPORTED_STYLES = {
    Button: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype, BorderRadiusMixin.prototype, TextColorMixin.prototype],
    Box: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype],
    Checkbox: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype, BorderRadiusMixin.prototype],
    UploadButton: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype, BorderRadiusMixin.prototype, TextColorMixin.prototype],
    TextInput: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype, BorderRadiusMixin.prototype, TextColorMixin.prototype],
    TextBox: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype, BorderRadiusMixin.prototype, TextColorMixin.prototype],
    Shape: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype],
    RadioButtonGroup: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype, BorderRadiusMixin.prototype, TextColorMixin.prototype],
    Header: [BackgroundColorMixin.prototype, BorderColorMixin.prototype],
    Footer: [BackgroundColorMixin.prototype, BorderColorMixin.prototype],
    Dropdown: [BackgroundColorMixin.prototype, BorderColorMixin.prototype, BorderWidthMixin.prototype, BorderRadiusMixin.prototype, TextColorMixin.prototype]
};

const StyleProperties = {
    BORDER_RADIUS: 'borderRadius',
    BORDER_WIDTH: 'borderWidth',
    BORDER_COLOR: 'borderColor',
    BACKGROUND_COLOR: 'backgroundColor',
    COLOR: 'color'
};

export {
    SUPPORTED_STYLES,
    StyleProperties
};



// WEBPACK FOOTER //
// ./js/modules/privates/styleConstants.es6